import { useMutation, useQueryClient } from "@tanstack/react-query";

import { GO_SERVICE_QUERY_KEYS } from "../queryKeys";
import { ContractAction } from "../types/contract.types";
import { respondToContract } from "../services/goHireService";

export const useRespondToContract = (requestId: number, contractId: number, options?: { onSuccess?: () => void }) => {
  const queryClient = useQueryClient();

  const invalidateAllRelatedQueries = () => {
    // Invalidate service request queries (base key will match all variations with params)
    queryClient.invalidateQueries({ queryKey: GO_SERVICE_QUERY_KEYS.serviceRequest(requestId) });

    // Invalidate contract details queries
    queryClient.invalidateQueries({ queryKey: GO_SERVICE_QUERY_KEYS.contractDetails(contractId) });

    // Invalidate all request lists
    queryClient.invalidateQueries({ queryKey: GO_SERVICE_QUERY_KEYS.orderedRequests() });
    queryClient.invalidateQueries({ queryKey: GO_SERVICE_QUERY_KEYS.receivedRequests() });
    queryClient.invalidateQueries({ queryKey: GO_SERVICE_QUERY_KEYS.orderedProgramRequests() });
    queryClient.invalidateQueries({ queryKey: GO_SERVICE_QUERY_KEYS.receivedProgramRequests() });

    // Invalidate all contract lists
    queryClient.invalidateQueries({ queryKey: GO_SERVICE_QUERY_KEYS.orderedContracts() });
    queryClient.invalidateQueries({ queryKey: GO_SERVICE_QUERY_KEYS.receivedContracts() });
  };

  return useMutation({
    mutationFn: (action: ContractAction) => respondToContract(contractId, { action }),
    onSuccess: () => {
      invalidateAllRelatedQueries();
      options?.onSuccess?.();
    },
    onError: () => {
      invalidateAllRelatedQueries();
    },
  });
};
